import { render, staticRenderFns } from "./OrderDetailQuac.vue?vue&type=template&id=6a360e44"
import script from "./OrderDetailQuac.vue?vue&type=script&lang=js"
export * from "./OrderDetailQuac.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports